import { FieldDisplaySetting, VerificationNames } from "shared/types";
import { VerificationSchemaView } from "./slices/types";

export const basicInformationTabs = [
  VerificationSchemaView.PersonalDetails,
  VerificationSchemaView.Dependents,
  VerificationSchemaView.EmergencyContacts,
  VerificationSchemaView.Pets,
  VerificationSchemaView.Vehicles,
  VerificationSchemaView.MilitaryFirstResponderTeacher,
  VerificationSchemaView.LeadSource,
  VerificationSchemaView.AdditionalQuestions
];

export const countWalkInTabs = [
  VerificationSchemaView.CountyWalkIn,
  VerificationSchemaView.CountyWalkInAutomatic,
  VerificationSchemaView.CountyWalkInManual
];

export const identityVerificationTabs = [
  VerificationSchemaView.IdentityVerification,
  VerificationSchemaView.IdentityRiskSignal
];

export const petScreeningReportTabs = [
  VerificationSchemaView.PetScreeningReport
];

export const incomeHistoryTabs = [
  VerificationSchemaView.BankVerification,
  VerificationSchemaView.PayrollVerification,
  VerificationSchemaView.DocumentVerification,
  VerificationSchemaView.Employment,
  VerificationSchemaView.SelfEmployed,
  VerificationSchemaView.OfferLetter,
  VerificationSchemaView.OtherIncome
];

export const combinedIncomeTabs = [
  VerificationSchemaView.CombinedEmployment,
  VerificationSchemaView.CombinedSelfEmployed,
  VerificationSchemaView.CombinedOfferLetter,
  VerificationSchemaView.CombinedOtherIncome,
  VerificationSchemaView.CombinedHousingAssistance
];

export const housingHistoryTabs = [
  VerificationSchemaView.GeneralHousingConfiguration,
  VerificationSchemaView.RentVerification,
  VerificationSchemaView.OwnVerification,
  VerificationSchemaView.OtherVerification
];

export const criminalReportTabs = [VerificationSchemaView.CriminalReport];

const countyWalkInTabs = [
  VerificationSchemaView.CountyWalkIn,
  VerificationSchemaView.CountyWalkInAutomatic,
  VerificationSchemaView.CountyWalkInManual
];

export const screeningServicesTabs = [
  ...basicInformationTabs,
  ...identityVerificationTabs,
  ...incomeHistoryTabs,
  ...combinedIncomeTabs,
  ...criminalReportTabs,
  ...housingHistoryTabs,
  ...countyWalkInTabs,
  ...petScreeningReportTabs
];

export const housingHistoryFallback = {
  rent_option_required: {
    landlord_phone: true,
    monthly_payment: true,
    reason_for_leaving: true,
    lease_document: false
  },
  own_home_option_required: {
    reason_for_leaving: true,
    monthly_mortgage_payment: true
  },
  other_option_required: {
    housing_status: true,
    reason_for_leaving: false
  }
};

export const combinedIncomeVerificationFallback = {
  combined_income_verification_enabled: false,
  housing_assistance_program_enabled: true,
  housing_assistance_upload: FieldDisplaySetting.Required,
  employment: {
    bank_allowed: true,
    payroll_allowed: true,
    paystub: {
      allowed: true,
      timeframe: { value: 3, unit: "month" }
    },
    bank_statement: {
      allowed: false,
      timeframe: { value: 3, unit: "month" }
    },
    w2: {
      allowed: true,
      timeframe: { value: 1, unit: "year" }
    },
    fields: {
      job_title: FieldDisplaySetting.Required,
      supervisor: {
        first_name: FieldDisplaySetting.Required,
        last_name: FieldDisplaySetting.Required,
        phone: FieldDisplaySetting.Required,
        email: FieldDisplaySetting.Required
      }
    }
  },
  self_employment: {
    bank_allowed: true,
    payroll_allowed: true,
    paystub: {
      allowed: true,
      timeframe: { value: 3, unit: "month" }
    },
    bank_statement: {
      allowed: false,
      timeframe: { value: 3, unit: "month" }
    },
    w2: {
      allowed: true,
      timeframe: { value: 1, unit: "year" }
    },
    fields: {
      job_title: FieldDisplaySetting.Required
    }
  },
  offer_letter: {
    fields: {
      job_title: FieldDisplaySetting.Required,
      supervisor: {
        first_name: FieldDisplaySetting.Required,
        last_name: FieldDisplaySetting.Required,
        phone: FieldDisplaySetting.Required,
        email: FieldDisplaySetting.Required
      },
      upload_offer_letter: FieldDisplaySetting.Required
    }
  },
  other: {
    bank_allowed: true,
    payroll_allowed: true,
    paystub: {
      allowed: true,
      timeframe: { value: 3, unit: "month" }
    },
    bank_statement: {
      allowed: false,
      timeframe: { value: 3, unit: "month" }
    },
    w2: {
      allowed: true,
      timeframe: { value: 1, unit: "year" }
    },
    fields: {
      income_description: FieldDisplaySetting.Required,
      paid_by_from: FieldDisplaySetting.Required,
      start_date: FieldDisplaySetting.Required,
      pre_tax_amount: FieldDisplaySetting.Required
    }
  }
};

export const VERIFICATIONS_WITH_TABS: {
  tabs: string[];
  title: string;
  verificationName: VerificationNames;
}[] = [
  {
    tabs: basicInformationTabs,
    title: "Basic information",
    verificationName: VerificationNames.RentalApplication
  },
  {
    tabs: identityVerificationTabs,
    title: "Identity verification",
    verificationName: VerificationNames.IdentityVerification
  },
  {
    tabs: incomeHistoryTabs,
    title: "Income history",
    verificationName: VerificationNames.IncomeVerification
  },
  {
    tabs: combinedIncomeTabs,
    title: "Income history",
    verificationName: VerificationNames.CombinedIncome
  },
  {
    tabs: housingHistoryTabs,
    title: "Housing history",
    verificationName: VerificationNames.HousingHistory
  }
];
